(function () {
  'use strict';

  if (window.__fwSearchReady) return;
  window.__fwSearchReady = true;

  var dialog = document.querySelector('[data-nh-search-dialog]');
  if (!dialog) return;

  var form = dialog.querySelector('[data-nh-search-form]');
  var input = dialog.querySelector('[data-nh-search-input]');
  var clearButton = dialog.querySelector('[data-nh-search-clear]');
  var initial = dialog.querySelector('[data-nh-search-initial]');
  var results = dialog.querySelector('[data-nh-search-results]');
  var loading = dialog.querySelector('[data-nh-search-loading]');
  var productsSection = dialog.querySelector('[data-nh-search-products-section]');
  var productsGrid = dialog.querySelector('[data-nh-search-products]');
  var productCount = dialog.querySelector('[data-nh-search-product-count]');
  var collectionsSection = dialog.querySelector('[data-nh-search-collections-section]');
  var collectionsGrid = dialog.querySelector('[data-nh-search-collections]');
  var empty = dialog.querySelector('[data-nh-search-empty]');
  var footer = dialog.querySelector('[data-nh-search-footer]');
  var viewAll = dialog.querySelector('[data-nh-search-all]');
  var status = dialog.querySelector('[data-nh-search-status]');
  var searchUrl = dialog.dataset.searchUrl || '/search';
  var predictiveUrl = dialog.dataset.predictiveUrl || '/search/suggest.json';
  var currency = dialog.dataset.currency || 'EUR';
  var cache = new Map();
  var timer = 0;
  var controller = null;
  var requestVersion = 0;
  var lastTrigger = null;
  var activeIndex = -1;

  var intentRules = [
    { pattern: /(main|mains|doigt|doigts)/, term: 'gants chauffants' },
    { pattern: /(pied|pieds|chaussette|chaussettes)/, term: 'chaussettes chauffantes' },
    { pattern: /(jambe|jambes|pantalon|legging)/, term: 'pantalon chauffant' },
    { pattern: /(moto|scooter|deux roues|velo|vélo)/, term: 'veste moto chauffante' },
    { pattern: /(travail|chantier|haute visibilite|haute visibilité)/, term: 'veste travail chauffante' },
    { pattern: /(sans manche|sans manches|gilet)/, term: 'gilet chauffant' },
    { pattern: /(batterie|autonomie|powerbank|recharge)/, term: 'batterie veste chauffante' }
  ];

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('fr')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function endpointTerm(value) {
    var normalized = normalize(value);
    for (var index = 0; index < intentRules.length; index += 1) {
      if (intentRules[index].pattern.test(normalized)) return intentRules[index].term;
    }
    return value.trim();
  }

  function formatMoney(value) {
    var amount = Number.parseFloat(value);
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function imageUrl(value, width) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return value;
    }
  }

  function setStatus(message) {
    status.textContent = message;
  }

  function setViewAll(query) {
    var url = new URL(searchUrl, window.location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('q', endpointTerm(query));
    viewAll.href = url.pathname + url.search;
  }

  function showInitial() {
    initial.hidden = false;
    results.hidden = true;
    footer.hidden = true;
    dialog.setAttribute('aria-busy', 'false');
    input.setAttribute('aria-expanded', 'false');
    setStatus('Suggestions de catégories et modèles populaires.');
  }

  function showLoading() {
    initial.hidden = true;
    results.hidden = false;
    loading.hidden = false;
    productsSection.hidden = true;
    collectionsSection.hidden = true;
    empty.hidden = true;
    footer.hidden = true;
    dialog.setAttribute('aria-busy', 'true');
    input.setAttribute('aria-expanded', 'true');
    setStatus('Recherche en cours.');
  }

  function makeProductCard(product) {
    var link = document.createElement('a');
    link.className = 'nh-search-card';
    link.href = product.url;
    link.setAttribute('role', 'option');
    link.setAttribute('data-nh-search-result', '');
    link.setAttribute('aria-selected', 'false');

    var media = document.createElement('span');
    media.className = 'nh-search-card__media';
    var source = product.featured_image && product.featured_image.url ? product.featured_image.url : product.image;
    if (source) {
      var image = document.createElement('img');
      image.src = imageUrl(source, 420);
      image.alt = (product.featured_image && product.featured_image.alt) || product.title || 'Produit FLINTWRK';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 420;
      image.height = 420;
      media.appendChild(image);
    } else {
      var placeholder = document.createElement('span');
      placeholder.className = 'nh-search-card__placeholder';
      placeholder.textContent = 'FLINTWRK';
      media.appendChild(placeholder);
    }

    var body = document.createElement('span');
    body.className = 'nh-search-card__body';
    var title = document.createElement('strong');
    title.textContent = product.title || 'Produit FLINTWRK';
    var price = document.createElement('span');
    price.className = 'nh-search-card__price';
    var current = document.createElement('b');
    current.textContent = formatMoney(product.price_min || product.price);
    price.appendChild(current);
    var priceValue = Number.parseFloat(product.price_min || product.price);
    var compareValue = NaN;
    if (Array.isArray(product.variants) && product.variants.length) {
      product.variants.forEach(function (variant) {
        var vp = Number.parseFloat(variant.price);
        var vc = Number.parseFloat(variant.compare_at_price);
        if (vp === priceValue && Number.isFinite(vc) && vc > vp && !(compareValue <= vc)) compareValue = vc;
      });
    } else if (product.price_max == null || Number.parseFloat(product.price_max) === priceValue) {
      compareValue = Number.parseFloat(product.compare_at_price_min || product.compare_at_price);
    }
    if (Number.isFinite(compareValue) && compareValue > priceValue) {
      var compare = document.createElement('s');
      compare.textContent = formatMoney(compareValue);
      price.appendChild(compare);
    }
    body.append(title, price);
    link.append(media, body);
    return link;
  }

  function makeCollectionLink(collection) {
    var link = document.createElement('a');
    link.className = 'nh-search-collection-link';
    link.href = collection.url;
    link.setAttribute('role', 'option');
    link.setAttribute('data-nh-search-result', '');
    link.setAttribute('aria-selected', 'false');
    link.textContent = collection.title || 'Collection FLINTWRK';
    var arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    link.appendChild(arrow);
    return link;
  }

  function renderData(data, query) {
    var resourceResults = data && data.resources && data.resources.results ? data.resources.results : {};
    var products = Array.isArray(resourceResults.products) ? resourceResults.products.slice(0, 6) : [];
    var collections = Array.isArray(resourceResults.collections) ? resourceResults.collections.slice(0, 4) : [];
    initial.hidden = true;
    results.hidden = false;
    loading.hidden = true;
    dialog.setAttribute('aria-busy', 'false');
    productsGrid.replaceChildren();
    collectionsGrid.replaceChildren();
    activeIndex = -1;

    products.forEach(function (product) {
      productsGrid.appendChild(makeProductCard(product));
    });
    collections.forEach(function (collection) {
      collectionsGrid.appendChild(makeCollectionLink(collection));
    });

    productsSection.hidden = products.length === 0;
    collectionsSection.hidden = collections.length === 0;
    empty.hidden = products.length + collections.length > 0;
    footer.hidden = products.length + collections.length === 0;
    productCount.textContent = products.length ? products.length + (products.length > 1 ? ' modèles' : ' modèle') : '';
    input.setAttribute('aria-expanded', products.length + collections.length > 0 ? 'true' : 'false');
    setViewAll(query);
    setStatus(
      products.length + collections.length > 0
        ? products.length + ' produits et ' + collections.length + ' collections trouvés.'
        : 'Aucun résultat trouvé.'
    );
  }

  function fetchResults(rawQuery) {
    var query = endpointTerm(rawQuery);
    var key = normalize(query);
    var version = ++requestVersion;
    setViewAll(rawQuery);

    if (cache.has(key)) {
      renderData(cache.get(key), rawQuery);
      return;
    }

    showLoading();
    if (controller) controller.abort();
    controller = new AbortController();
    var url = new URL(predictiveUrl, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product,collection');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    url.searchParams.set('resources[options][fields]', 'title,product_type,tag,variants.title');

    fetch(url.toString(), {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.json();
      })
      .then(function (data) {
        if (version !== requestVersion) return;
        if (cache.size >= 20) cache.delete(cache.keys().next().value);
        cache.set(key, data);
        renderData(data, rawQuery);
      })
      .catch(function (error) {
        if (error.name === 'AbortError' || version !== requestVersion) return;
        loading.hidden = true;
        dialog.setAttribute('aria-busy', 'false');
        productsSection.hidden = true;
        collectionsSection.hidden = true;
        empty.hidden = false;
        footer.hidden = true;
        setStatus('La recherche est momentanément indisponible.');
      });
  }

  function queueSearch() {
    var query = input.value.trim();
    clearButton.hidden = query.length === 0;
    window.clearTimeout(timer);
    if (query.length < 2) {
      requestVersion += 1;
      if (controller) controller.abort();
      showInitial();
      return;
    }
    timer = window.setTimeout(function () {
      fetchResults(query);
    }, 180);
  }

  function openSearch(event, trigger) {
    if (typeof dialog.showModal !== 'function') return;
    if (event) event.preventDefault();
    lastTrigger = trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();
    window.requestAnimationFrame(function () {
      input.focus({ preventScroll: true });
    });
    if (window.dataLayer) window.dataLayer.push({ event: 'flintwrk_search_open' });
  }

  function closeSearch() {
    if (dialog.open) dialog.close();
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var trigger = event.target.closest('[data-nh-search-open]');
    if (trigger) openSearch(event, trigger);
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog || (event.target instanceof Element && event.target.closest('[data-nh-search-close]'))) closeSearch();
  });

  dialog.addEventListener('close', function () {
    window.clearTimeout(timer);
    requestVersion += 1;
    if (controller) controller.abort();
    input.value = '';
    clearButton.hidden = true;
    showInitial();
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus({ preventScroll: true });
  });

  input.addEventListener('input', queueSearch);

  clearButton.addEventListener('click', function () {
    input.value = '';
    clearButton.hidden = true;
    showInitial();
    input.focus();
  });

  dialog.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var queryButton = event.target.closest('[data-nh-search-query]');
    if (!queryButton) return;
    input.value = queryButton.dataset.nhSearchQuery || '';
    clearButton.hidden = false;
    input.focus();
    fetchResults(input.value);
  });

  form.addEventListener('submit', function (event) {
    var rawQuery = input.value.trim();
    if (!rawQuery) {
      event.preventDefault();
      input.focus();
      return;
    }
    var mappedQuery = endpointTerm(rawQuery);
    if (mappedQuery !== rawQuery) {
      event.preventDefault();
      var target = new URL(searchUrl, window.location.origin);
      target.searchParams.set('type', 'product');
      target.searchParams.set('options[prefix]', 'last');
      target.searchParams.set('q', mappedQuery);
      window.location.assign(target.toString());
    }
    if (window.dataLayer) window.dataLayer.push({ event: 'flintwrk_search_submit', search_term: mappedQuery });
  });

  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') return;
    var items = Array.prototype.slice.call(dialog.querySelectorAll('[data-nh-search-result]'));
    if (!items.length || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;
    event.preventDefault();
    if (event.key === 'ArrowDown') activeIndex = Math.min(activeIndex + 1, items.length - 1);
    if (event.key === 'ArrowUp') activeIndex = Math.max(activeIndex - 1, 0);
    items.forEach(function (item, index) {
      item.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
    });
    items[activeIndex].focus({ preventScroll: true });
    items[activeIndex].scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });

  showInitial();
})();
